import { AdvertiserData } from '../interfaces';

export const ADVERTISER_DATA: AdvertiserData = {
    id: { label: 'ID', value: '1' },
    name: { label: 'Name', value: 'Zone 1 - Peppa Flame Restaurant and Lounge' },
    image: 'https://picsum.photos/200/300',
    dealerInfo: [
        { label: 'Assigned Dealer', value: 'Noob Inc.' },
        { label: 'Contacts', value: 'John Doe' },
        { label: 'Phone', value: '(312) 555-0123' },
        { label: 'Address', value: '900 S Wabash Ave, Chicago, IL 60605' },
    ],
};

export const TAGS: { label: string; color: string }[] = [
    { label: 'SnapPoints', color: '#E53E3E' },
    { label: 'PixelPower', color: '#D69E2E' },
    { label: 'PromoUp', color: '#38A169' },
    { label: 'AdStream', color: '#3182CE' },
    { label: 'CampaignBoost', color: '#805AD5' },
];
